@if (userFacade.user$ | async; as user) {
  <router-outlet></router-outlet>
  <app-dialog-host></app-dialog-host>
}
